export var Labels = {
    paymentProcessing: 'ระบบกำลังดำเนินการ กรุณารอซักครู่'
};
